module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAP0lEQVRIx+3WsQ0AIAwDQYctMiJVtoFxTccGREL6X+DkzuHKJWnqfVuudEuVHg2LbmBgYGBgYGBgYN9i0fmID0tDbxVDbwlbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/the_pwd.png
// module id = Sy/2
// module chunks = 1